import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  Box,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import PeopleIcon from "@mui/icons-material/People";
import SyncIcon from "@mui/icons-material/Sync";
import { useNavigate } from "react-router-dom";
import {
  logoutAsync,
  selectIsAuthenticated,
  selectUserProfile,
} from "../../features/authentication/authenticationSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { ROUTES } from "../../routes/routes";

const Header = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const user = useAppSelector(selectUserProfile);
  const dispatch = useAppDispatch();
  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    await dispatch(logoutAsync());
  };

  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  return (
    <AppBar
      position="static"
      sx={{
        background: "linear-gradient(135deg, #0a6baa 0%, #0e86d4 50%, #1a9be6 100%)",
        backdropFilter: "blur(20px) saturate(180%)",
        WebkitBackdropFilter: "blur(20px) saturate(180%)",
      }}
    >
      <Toolbar
        sx={{
          maxWidth: { xl: "1536px" },
          mx: "auto",
          width: "100%",
          px: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Box
          onClick={() => navigate("/")}
          sx={{
            cursor: "pointer",
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <svg width="28" height="28" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M32 320 L144 320 L192 384 L280 128 L328 384 L380 320 L480 320" stroke="#ffffff" strokeWidth="28" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
            <line x1="280" y1="36" x2="280" y2="116" stroke="#ffffff" strokeWidth="12" strokeLinecap="round"/>
            <line x1="240" y1="76" x2="320" y2="76" stroke="#ffffff" strokeWidth="12" strokeLinecap="round"/>
            <line x1="248" y1="44" x2="312" y2="108" stroke="#ffffff" strokeWidth="12" strokeLinecap="round"/>
            <line x1="312" y1="44" x2="248" y2="108" stroke="#ffffff" strokeWidth="12" strokeLinecap="round"/>
          </svg>
          <Typography
            variant="h6"
            component="div"
            sx={{
              fontWeight: 700,
              letterSpacing: "-0.02em",
              fontSize: "1.25rem",
            }}
          >
            TeamRay
          </Typography>
        </Box>
        {isAuthenticated ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <IconButton onClick={handleMenuOpen} sx={{ p: 0 }}>
              <Avatar
                alt="User Image"
                src={user.picture}
                sx={{
                  width: 36,
                  height: 36,
                  border: "2px solid rgba(255,255,255,0.4)",
                }}
              />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <Box sx={{ px: 2, py: 1.5, minWidth: 200 }}>
                {user.name && (
                  <Typography variant="body2" sx={{ fontWeight: 600, color: "text.primary" }}>
                    {user.name}
                  </Typography>
                )}
                <Typography variant="caption" sx={{ color: "text.secondary" }}>
                  {user.emailaddress || "No Email"}
                </Typography>
              </Box>
              <Divider sx={{ my: 0.5 }} />
              {user.role === "Admin" && (
                <>
                  <MenuItem
                    onClick={() => {
                      navigate(ROUTES.SYNC_DASHBOARD);
                      handleMenuClose();
                    }}
                  >
                    <ListItemIcon>
                      <SyncIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Sync Dashboard</ListItemText>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigate(ROUTES.USER_PROJECT_ACCESSES);
                      handleMenuClose();
                    }}
                  >
                    <ListItemIcon>
                      <PeopleIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>User Projects Access</ListItemText>
                  </MenuItem>
                </>
              )}
              <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                  <LogoutIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Logout</ListItemText>
              </MenuItem>
            </Menu>
          </Box>
        ) : (
          <></>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
